import React from 'react'

import * as S from './EditorPanel.styled'
import { EditorPanelHeader } from './EditorPanelHeader/EditorPanelHeader'
import { EditorPanelSubheader } from './EditorPanelSubheader/EditorPanelSubheader'
import { EditorPanelWrapper } from './EditorPanelWrapper/EditorPanelWrapper'
import type { Props } from './types'

export const EditorPanel = ({ children }: Props) => {
  return <S.Container>{children}</S.Container>
}

EditorPanel.Wrapper = EditorPanelWrapper
EditorPanel.Header = EditorPanelHeader
EditorPanel.Subheader = EditorPanelSubheader
